import { render, staticRenderFns } from "./DelivererPopup.vue?vue&type=template&id=4c2dba95&"
import script from "./DelivererPopup.vue?vue&type=script&lang=js&"
export * from "./DelivererPopup.vue?vue&type=script&lang=js&"
import style0 from "./DelivererPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports